import { useContext } from 'react';

import { BP42Ctx } from '~/src/packages/bp42/BP42Context';
import { BP42InitialState } from '~/src/packages/bp42/reducer/initialState';

const useCtxSelector = <T>(selector: (state: BP42InitialState) => T) => {
    const { state } = useContext(BP42Ctx);

    return selector(state);
};

export default useCtxSelector;
